import React from 'react';
import MenuRight from './MenuRight';
import MenuBottom from './MenuBottom.js';
import CenterButtons from './CenterButtons.js';
import Diamond from './images/Diamond.png';
import ActivityImg from './images/Tasks.png';

function Tasks({ changeActiveComponent }) {
  const changeComponent = (id) => {
    if (id === 'assign') {
      changeActiveComponent('tasksassign');
    } else if (id === 'assigned') {
      changeActiveComponent('tasksunassign');
    }
  };

  return (
    <section id="tasks">
      <div className="platform-container">
      <div className="platform-activity-container">
          <div className="activity-container">
            <div className="activity-image-container"><img src={ActivityImg}/></div>
            <div className="activity-activity-container"><h2>TASKS</h2><p>Assign your ANT to complete tasks in exchange for purses. Harder the task
is more purses will be rewarded! Task is assigned by random.</p></div>
            <div className="activity-advantages-container"><h2>ADVANTAGE</h2><p>Rogue ANT has better rate getting assigned in high paying task!</p></div>
            <CenterButtons changeComponent={changeComponent} /></div>
          </div>
      </div>
    </section>
  );
}

export default Tasks;